import React from 'react';
import { useTranslation } from 'react-i18next';

import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import SubTaskDetails from './SubTaskDetails';

const ApprovalSubTaskList = props => {
  const { t } = useTranslation();

  const {
    isLoading,
    subTasksList,
    updateSubTaskStatusRequest,
    selectedTab,
    getSubTaskEvidence,
  } = props;

  return (
    <>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : subTasksList && subTasksList.length > 0 ? (
        subTasksList.map(subTask => (
          <SubTaskDetails
            key={subTask.id}
            subTaskDetails={subTask}
            approvalMode
            selectedTab={selectedTab}
            updateSubTaskStatusRequest={updateSubTaskStatusRequest}
            getSubTaskEvidence={getSubTaskEvidence}
          />
        ))
      ) : (
        <NoDataComponent
          title={t('no_subtasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </>
  );
};

export default ApprovalSubTaskList;
